var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable camelcase */
import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import { useDispatch } from 'react-redux';
import { CollectEmailsForm } from './collect_emails_form';
import { ConfirmAddEmailsToTeamAccountAndGroup } from './confirm_add_emails_to_team_account_and_group';
import InformUserCannotAddEmailContent from './InformUserCannotAddEmails';
import { mapAddTeamMembersToGroupByEmailResponse, mapInviteTeamMembersAndAddToGroupByEmailResponse, } from './map_response_utils';
import track from '../../../utils/track';
import { GroupsMembersEvents } from '../../../constants/events';
export var ModalSteps;
(function (ModalSteps) {
    ModalSteps["COLLECT_AND_ADD_EMAILS"] = "COLLECT_AND_ADD_EMAILS";
    ModalSteps["ASK_USER_TO_ADD_EMAILS_TO_TEAM_ACCOUNT"] = "ASK_USER_TO_ADD_EMAILS_TO_TEAM_ACCOUNT";
    ModalSteps["INFORM_USER_CANNOT_ADD_EMAIL"] = "INFORM_USER_CANNOT_ADD_EMAIL";
    ModalSteps["CLOSE"] = "CLOSE";
})(ModalSteps || (ModalSteps = {}));
export var BulkAddMembersToGroupModal = function (_a) {
    var group = _a.group, teamAccount = _a.teamAccount, teamAccountPlanMembersInfo = _a.teamAccountPlanMembersInfo, onClose = _a.onClose, onSuccess = _a.onSuccess;
    var _b = __read(React.useState(ModalSteps.COLLECT_AND_ADD_EMAILS), 2), step = _b[0], setStep = _b[1];
    var _c = __read(React.useState(''), 2), title = _c[0], setTitle = _c[1];
    var _d = __read(React.useState(0), 2), successAddToGroupCount = _d[0], setSuccessAddToGroupCount = _d[1];
    var _e = __read(React.useState(null), 2), successInviteThenAddToGroupCount = _e[0], setSuccessInviteThenAddToGroupCount = _e[1]; // initialize to NULL because we may not get to step 2
    var _f = __read(React.useState([]), 2), memberEmailsThatCanBeAddedToTeamAndGroup = _f[0], setMemberEmailsThatCanBeAddedToTeamAndGroup = _f[1];
    var _g = __read(React.useState([]), 2), addTeamMemberToGroupErrors = _g[0], setAddTeamMemberToGroupErrors = _g[1];
    var _h = __read(React.useState([]), 2), inviteTeamMemberErrors = _h[0], setInviteTeamMemberErrors = _h[1];
    var _j = __read(React.useState(false), 2), isReadyForNextStep = _j[0], setIsReadyForNextStep = _j[1];
    var dispatch = useDispatch();
    React.useEffect(function () {
        // useEffect is exclusive to handle the next step of modal content
        if (isReadyForNextStep) {
            setIsReadyForNextStep(false);
            // calculates the next step based on use case scenarios
            if (step === ModalSteps.COLLECT_AND_ADD_EMAILS) {
                if (memberEmailsThatCanBeAddedToTeamAndGroup.length) {
                    setStep(ModalSteps.ASK_USER_TO_ADD_EMAILS_TO_TEAM_ACCOUNT);
                    return;
                }
                else if (addTeamMemberToGroupErrors.length) {
                    setStep(ModalSteps.INFORM_USER_CANNOT_ADD_EMAIL);
                    return;
                }
                // the else confirms that all members were added successfully and no next step required
            }
            else if (step === ModalSteps.ASK_USER_TO_ADD_EMAILS_TO_TEAM_ACCOUNT) {
                if (addTeamMemberToGroupErrors.length) {
                    setStep(ModalSteps.INFORM_USER_CANNOT_ADD_EMAIL);
                    return;
                }
            }
            setStep(ModalSteps.CLOSE);
        }
    }, [
        isReadyForNextStep,
        addTeamMemberToGroupErrors.length,
        memberEmailsThatCanBeAddedToTeamAndGroup.length,
        step,
    ]);
    React.useEffect(function () {
        if (step === ModalSteps.CLOSE) {
            var totalSuccess = successAddToGroupCount + successInviteThenAddToGroupCount;
            track(GroupsMembersEvents.ADD_MEMBERS_SUCCESS, {
                group_id: group.id,
                group_name: group.name,
                email_count: totalSuccess,
            });
            if (!!totalSuccess) {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(group, { memberCount: totalSuccess });
            }
            onClose();
        }
    }, [
        group,
        onClose,
        onSuccess,
        step,
        successAddToGroupCount,
        successInviteThenAddToGroupCount,
    ]);
    var handleAddToGroup = function (responseData) {
        var _a = mapAddTeamMembersToGroupByEmailResponse(responseData), successCount = _a.successCount, emailsOfMembersToInvite = _a.emailsOfMembersToInvite, cannotInviteMembers = _a.cannotInviteMembers;
        setSuccessAddToGroupCount(successCount);
        setMemberEmailsThatCanBeAddedToTeamAndGroup(emailsOfMembersToInvite);
        setAddTeamMemberToGroupErrors(cannotInviteMembers);
        setIsReadyForNextStep(true);
        // TODO: Not handling payloadSizeError from response (follow up in V2)
    };
    var handleInviteToTeamAndGroup = function (responseData) {
        var _a = mapInviteTeamMembersAndAddToGroupByEmailResponse(responseData), successCount = _a.successCount, addToGroupErrors = _a.addToGroupErrors, inviteErrors = _a.inviteErrors;
        setSuccessInviteThenAddToGroupCount(successCount);
        var combinedAddToGroupErrors = addTeamMemberToGroupErrors.concat(addToGroupErrors);
        setAddTeamMemberToGroupErrors(combinedAddToGroupErrors);
        setInviteTeamMemberErrors(inviteErrors);
        setIsReadyForNextStep(true);
    };
    if (!group) {
        return null;
    }
    return (React.createElement(Modal, { onClose: onClose, title: title }, step === ModalSteps.COLLECT_AND_ADD_EMAILS ? (React.createElement(CollectEmailsForm, { setTitle: setTitle, group: group, dispatch: dispatch, onClose: onClose, onAddComplete: handleAddToGroup })) : step === ModalSteps.ASK_USER_TO_ADD_EMAILS_TO_TEAM_ACCOUNT ? (React.createElement(ConfirmAddEmailsToTeamAccountAndGroup, { setTitle: setTitle, teamAccount: teamAccount, teamAccountPlanMembersInfo: teamAccountPlanMembersInfo, group: group, emails: memberEmailsThatCanBeAddedToTeamAndGroup, onDoNotAdd: function () { return setIsReadyForNextStep(true); }, onAddComplete: handleInviteToTeamAndGroup })) : step === ModalSteps.INFORM_USER_CANNOT_ADD_EMAIL ? (React.createElement(InformUserCannotAddEmailContent, { group: group, errors: {
            addTeamMemberToGroupErrors: addTeamMemberToGroupErrors,
            inviteTeamMemberErrors: inviteTeamMemberErrors,
        }, onClose: function () { return setIsReadyForNextStep(true); }, setTitle: setTitle })) : null));
};
export default BulkAddMembersToGroupModal;
